import { render, staticRenderFns } from "./RestaurantMoreRestaurantsStats.vue?vue&type=template&id=e425cee6"
import script from "./RestaurantMoreRestaurantsStats.vue?vue&type=script&lang=js"
export * from "./RestaurantMoreRestaurantsStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports